import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";

function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (it) return (it = it.call(o)).next.bind(it);

  if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
    if (it) o = it;
    var i = 0;
    return function () {
      if (i >= o.length) return {
        done: true
      };
      return {
        done: false,
        value: o[i++]
      };
    };
  }

  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

import React, { useCallback } from 'react';
import '../../utils/assertions.es.js';
import { warn, runIfFn } from '../../utils/functions.es.js';
import '../../utils/responsive.es.js';
import '../../utils/scrollIntoView.es.js';
import 'polished';
import '@styled-system/css';
import 'styled-components';
import '../../utils/useEnhancedEffect.es.js';
import 'react-is';
import { Box } from '../../primitives/Box/Box.es.js';
import { forwardRef } from '../../system/forwardRef.es.js';
import { useImage } from './useImage.es.js';
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;

var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};

var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }

  if (__getOwnPropSymbols) {
    for (var _iterator = _createForOfIteratorHelperLoose(__getOwnPropSymbols(b)), _step; !(_step = _iterator()).done;) {
      var prop = _step.value;
      if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    }
  }

  return a;
};

var __objRest = function __objRest(source, exclude) {
  var target = {};

  for (var prop in source) {
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  }

  if (source != null && __getOwnPropSymbols) {
    for (var _iterator2 = _createForOfIteratorHelperLoose(__getOwnPropSymbols(source)), _step2; !(_step2 = _iterator2()).done;) {
      var prop = _step2.value;
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
  }

  return target;
};

var Image = forwardRef(function (props, ref) {
  var _a = props,
      _a$as = _a.as,
      as = _a$as === void 0 ? "img" : _a$as,
      src = _a.src,
      srcSet = _a.srcSet,
      fallbackSrc = _a.fallbackSrc,
      fallbackHandler = _a.fallbackHandler,
      fallback = _a.fallback,
      onLoad = _a.onLoad,
      onError = _a.onError,
      rest = __objRest(_a, ["as", "src", "srcSet", "fallbackSrc", "fallbackHandler", "fallback", "onLoad", "onError"]);

  var status = useImage(props);
  warn({
    condition: !!fallbackHandler,
    message: "The `fallbackHandler` prop is deprecated and will be removed in v1, use `fallback` instead"
  });
  var getFallback = useCallback(function () {
    if (fallback) {
      return runIfFn(fallback);
    }

    if (fallbackHandler && status.isFailed) return runIfFn(fallbackHandler);
    return (
      /* @__PURE__ */
      React.createElement(Box, __spreadValues({
        as: as,
        ref: ref,
        src: fallbackSrc
      }, rest))
    );
  }, [as, fallback, fallbackHandler, fallbackSrc, ref, rest, status.isFailed]);

  if (src) {
    if (status.isFailed) {
      return getFallback();
    }
  } else if (!src) {
    if (status.isFailed || status.isPending) {
      return getFallback();
    }
  }

  return (
    /* @__PURE__ */
    React.createElement(Box, __spreadValues({
      as: as,
      ref: ref,
      src: src,
      srcSet: srcSet
    }, rest))
  );
});
Image.displayName = "Image";
Image.defaultProps = {
  draggable: false
};
export { Image };